const WishlistManager = {
    get: () => JSON.parse(localStorage.getItem('wishlist') || '[]'),

    set: (list) => {
        localStorage.setItem('wishlist', JSON.stringify(list));
        // Emette un evento per notificare altre parti del tema (es. contatore header)
        document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
    },

    toggle: (handle, btnElement) => {
        let list = WishlistManager.get();
        const index = list.indexOf(handle);

        if (index > -1) {
            // RIMUOVI
            list.splice(index, 1);
            if (btnElement) btnElement.classList.remove('active');
        } else {
            // AGGIUNGI
            list.push(handle);
            if (btnElement) btnElement.classList.add('active');
        }

        WishlistManager.set(list);
    },

    init: () => {
        const list = WishlistManager.get();

        // 1. Accendi i cuori dei prodotti già in lista in tutta la pagina
        document.querySelectorAll('.wishlist-toggle-btn').forEach(btn => {
            if (list.includes(btn.dataset.productHandle)) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }
};

// Inizializza al caricamento pagina e dopo ricaricamenti AJAX (es. filtri collection)
document.addEventListener('DOMContentLoaded', WishlistManager.init);
document.addEventListener('shopify:section:load', WishlistManager.init);

// Sincronizza tab diverse del browser
window.addEventListener('storage', () => WishlistManager.init());
